import { render, staticRenderFns } from "./slide_images.vue?vue&type=template&id=0f80433b&scoped=true&"
import script from "./slide_images.vue?vue&type=script&lang=js&"
export * from "./slide_images.vue?vue&type=script&lang=js&"
import style0 from "./slide_images.vue?vue&type=style&index=0&id=0f80433b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f80433b",
  null
  
)

export default component.exports